import React, { useEffect } from 'react';
import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import { AddChannelPlus, InstaIconEmpty } from '../../assets/icons';
import { colors } from '../../styles/color';

interface Props {
  profileData?: any;
  handleSubmit?: () => void;
}

const EmptyInsta = ({ profileData, handleSubmit }: Props) => {
  const navigate = useNavigate();
console.log("hdhewhduw")
  const handleInstagramLogin = () => {
    const authUrl = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${process.env.REACT_APP_INSTAGRAM_APP_ID}&redirect_uri=${process.env.REACT_APP_INSTAGRAM_REDIRECT_URI}&response_type=code&scope=instagram_business_basic%2Cinstagram_business_manage_messages%2Cinstagram_business_manage_comments%2Cinstagram_business_content_publish%2Cinstagram_business_manage_insights`;
    window.location.href = authUrl;
    if (handleSubmit) {
    } else {
      // handleSubmit();  
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    console.log("urlParams: ", urlParams);
    const code = urlParams.get("code");
    console.log("code: ", code);
    if (code) {
      localStorage.setItem("instagramCode", code);
      navigate("/add-account");
    }
  }, [navigate]);

  return (
    // <Box>
      <Box
        // m='auto'
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "calc(100vh - 120px)",
          background: colors.dark[800],
          borderRadius: "12px",
          padding: "40px 20px",
          width: "100%",
        }}
      >
        <Box>
          <InstaIconEmpty />
        </Box>
        {/* <Box mt={'28px'}> */}
          <Typography variant='body1'   sx={{
          color: colors.gray[300],
          fontSize: "16px",
          fontWeight: "400",
          textAlign: "center",
          marginBottom: "32px",
        }}>
            No Account added yet
          </Typography>
        {/* </Box> */}
        {/* <Box sx={{ width: '280px', mt: '44px' }}> */}
          <Button 
           variant="contained"
            startIcon={<AddChannelPlus />}
            onClick={handleInstagramLogin}
            sx={{ width: 'fit-content', padding: '0 34px' }} 
          >
            Add Account
          </Button>
        {/* </Box> */}
      </Box>
 
  );
};

export default EmptyInsta;